import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Curso } from '../models/curso.model'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class SisespService {

  private baseUrl: string
  private link: string

  constructor(private http: HttpClient) {
    this.baseUrl = environment.sisespUrlApi
    this.link = environment.sisespUrl
  }

  inscricaoAberta(): Observable<Curso[]> {
    return this.http.get<Curso[]>(`${this.baseUrl}/publico/cursos/inscricao-aberta`, { headers: new HttpHeaders(), withCredentials: false })
  }

  proximos(): Observable<Curso[]> {
    return this.http.get<Curso[]>(`${this.baseUrl}/publico/cursos/proximos`, { headers: new HttpHeaders(), withCredentials: false })
  }

  emAndamento(): Observable<Curso[]> {
    return this.http.get<Curso[]>(`${this.baseUrl}/publico/cursos/em-andamento`, { headers: new HttpHeaders(), withCredentials: false })
  }

  acessar(id: number): void {
    window.open(`${this.link}/curso/${id}`, '_blank')
  }
}
